import type React from "react";

import { HealthReportsV2 } from "../components/HealthReports/HealthReportsV2";

export const HealthQuestionnairesV2: React.FC = () => {
  return (
    <div data-testid="health-questionnaires-v2">
      <HealthReportsV2 />
    </div>
  );
};
